<template>
  <el-dialog :title="payWay == 'yinlianStore'||payWay == 'tonglianStore' ? '扫码支付':(payWayDescription=='' || payWayDescription==undefined ? '现金': payWayDescription)" :visible.sync="dialogCashFlag" width="450px" :close-on-click-modal="false" :close-on-press-escape="false" :before-close="cancel" :show-close='false'>
    <div slot="title" class="dialogTitle">
      <div class="close cur" @click="cancel"><img src="../../assets/images/new/delete.png" alt=""></div>
      <div>{{payWay == 'yinlianStore'||payWay == 'tonglianStore' ? '扫码支付':(payWayDescription=='' || payWayDescription==undefined ? '现金': payWayDescription)}}</div>
    </div>
    <div class="cash pt24">
      <span class="titles">{{title}}</span>
      <div class="cashMoney fontSize28">￥<span class="cash-price">{{money}}</span></div>
      <div class="content" v-if="payWay != 'yinlianStore' && payWay != 'tonglianStore'">
        <div>支付方式</div>
        <div>{{(payWayDescription=='' || payWayDescription==undefined? '现金': payWayDescription)}}</div>
      </div>
      <div v-if="payWay == 'yinlianStore' || payWay == 'tonglianStore'">
        <div class="mt20"><img src="../../assets/images/new/scanTheCode.png" alt=""></div>
        <div class="color999 pt24">请使用扫码盒子收款</div>
        <!-- <el-input v-model="scanCode"></el-input> -->
      </div>
    </div>
    <span slot="footer" class="dialog-footer" v-if="payWay != 'yinlianStore'&&payWay != 'tonglianStore'">
      <el-button type="primary" @click="onSubmit">确定支付</el-button>
    </span>
  </el-dialog>

</template>

<script>

export default {
    data () {
      return {
        dialogCashFlag: false,
        title: "",
        scanCode: '',
        lastCode: '',      // 去重：记录上一次提交的码
        debounceTimer: null, // 防抖定时器（针对不带 Enter 模式）
        isSubmitting: false, // 防止重复提交
      }
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.onKeydown);
    clearTimeout(this.debounceTimer);
  },
    created () {
      this.init();
    },
    props: ["money","showTitle",'payWay','payWayDescription'],
    methods: {
      init () {
        this.$on("set", function(org) {
            // 重置状态（避免用 Object.assign 暴力重置）
          this.scanCode = '';
          this.lastCode = '';
          this.isSubmitting = false;
          clearTimeout(this.debounceTimer);

          // 先移除再添加，防止监听器累积
          window.removeEventListener('keydown', this.onKeydown);
          window.addEventListener('keydown', this.onKeydown);

          // 设置标题
          if (org === "member") {
            this.title = "会员充值";
          } else if (this.showTitle == "openCard" || this.showTitle == 'card') {
            this.title = "会员开卡收款";
          } else if (this.showTitle == "repair") {
            this.title = "修护开卡收款";
          } else {
            this.title = "产品项目收款";
          }
          this.dialogCashFlag = true;
        })
      },
      inits (org) {
        this.scanCode = "";
        if (this.timeId) {
          clearInterval(this.timeId);
          this.timeId = null;
        }
        window.addEventListener("keydown", this.onKeydown)
        if (org === "member") {
            this.title = "会员充值"
        } else if (this.showTitle == "openCard" || this.showTitle == 'card') {
            this.title = "会员开卡收款"
        } else if (this.showTitle == "repair") {
            this.title = "修护开卡收款"
        } else {
          this.title = "产品项目收款"
        }
        this.dialogCashFlag = true;
      },
      onKeydown(e) {
      // 1. 处理功能键（忽略 Shift、Ctrl 等）
      if (e.key === 'Shift' || e.key === 'Control' || e.key === 'Alt' || e.key === 'Meta') {
        return;
      }

      // 2. 【带 Enter 模式】捕获回车，立即提交
      if (e.key === 'Enter') {
        e.preventDefault(); // 防止意外触发表单提交
        this.handleScanResult(this.scanCode);
        return;
      }
      
      // 3. 只处理单字符（扫码枪输入）
      if (e.key.length === 1) {
        this.scanCode += e.key;

        // 重置防抖定时器（针对【不带 Enter 模式】）
        clearTimeout(this.debounceTimer);
        this.debounceTimer = setTimeout(() => {
          // 若 800ms 内无新字符，自动提交
          if (this.scanCode.length > 0) {
            this.handleScanResult(this.scanCode);
          }
        }, 800);
      }
    },

    handleScanResult(code) {
      // 去重：如果码为空、与上次相同、或正在提交中，则忽略
      if (!code || code === this.lastCode || this.isSubmitting) {
        return;
      }

      this.isSubmitting = true;
      this.lastCode = code;

      // 关闭对话框并清理
      this.dialogCashFlag = false;
      this.cleanup();

      // 通知父组件
      this.$emit("handleChange", code);
    },

    cleanup() {
      window.removeEventListener('keydown', this.onKeydown);
      clearTimeout(this.debounceTimer);
      this.isSubmitting = false;
    },

    onSubmit() {
      this.dialogCashFlag = false;
      this.cleanup();
      this.$emit("handleChange", true);
    },

    cancel() {
      this.scanCode = '';
      this.dialogCashFlag = false;
      this.cleanup();
      this.$emit("handleChange", false);
    },
    }
}
</script>

<style lang="less" scoped>

/deep/ .el-dialog__body {
    height: auto !important;
    padding: 0 25px 30px;
}
/deep/ .el-dialog__footer {
  padding: 0 0 40px;
  text-align: center;
}
.cash {
    font-size: 16px;
    color: #666;
    text-align: center;
}

.cashMoney {
    color: #333;
    font-weight: 700;
    padding: 10px 0;
}
.cash-price {
    font-size: 36px;
}
.content {
    display: flex;
    justify-content: space-between;
    padding: 10px 10px 0;
    border-top: 1px solid #F5F5F5;
}
.dialogTitle {
  width: 100%;
  display: flex;
  justify-content: space-between;
  font-size: 16px;
  font-weight: 700;
  .close {
    width: 14px;
    height: 14px;
    img {
      width: 100%;
      height: 100%;
      vertical-align: middle;
    }
  }
}
</style>